import UsernameOrNonprofitOrFundraiserPage, { getServerSideProps } from "./";

export default UsernameOrNonprofitOrFundraiserPage;
export { getServerSideProps };
